import { ReactNode } from 'react';
import { 
  // Main menu icons
  LayoutDashboard, 
  Bell, 
  FolderClosed, 
  Cpu, 
  Settings,
  Cable,
  BarChart3,
  ClipboardList,
  
  // Repository submenu icons
  AppWindow,
  HardDrive,
  KeyRound,
  Timer,
  
  // Management submenu icons
  Smartphone,
  Boxes,
  FileText,
  Calendar,
  
  // System submenu icons
  Cog,
  Users as UsersIcon,
  Briefcase,
  MapPin,
  User,
  Shield,

  UserRound,
  Inbox,

} from 'lucide-react';

export interface NavItem {
  icon: ReactNode;
  label: string;
  path?: string;
  children?: NavItem[];
  dividerAfter:Boolean;
}

export const sidebarItems: NavItem[] = [
  { 
    icon: <LayoutDashboard strokeWidth={1.5} size={24} />, 
    label: 'Dashboard', 
    path: '/dashboard',
    dividerAfter:false 
  },
  { 
    icon: <Bell strokeWidth={1.5} size={24} />, 
    label: 'Alerts', 
    path: '/alerts',
    dividerAfter:false
  },
  { 
    icon: <FolderClosed strokeWidth={1.5} size={24} />, 
    label: 'Repository',
    children: [
      { icon: <AppWindow strokeWidth={1.5} size={20} />, label: 'Apps', path: '/repository/apps',dividerAfter:false },
      { icon: <HardDrive strokeWidth={1.5} size={20} />, label: 'Firmware', path: '/repository/firmware',dividerAfter:false },
      { icon: <KeyRound strokeWidth={1.5} size={20} />, label: 'Key Management', path: '/repository/key-management',dividerAfter:false },
      { icon: <Timer strokeWidth={1.5} size={20} />, label: 'Task Automation', path: '/repository/task-automation',dividerAfter:false }
    ],
    dividerAfter:false

  },
  { 
    icon: <Cpu strokeWidth={1.5} size={24} />, 
    label: 'Management',
    children: [
      { icon: <Smartphone strokeWidth={1.5} size={20} />, label: 'Devices', path: '/management/devices' ,dividerAfter:false},
      { icon: <Boxes strokeWidth={1.5} size={20} />, label: 'Device Groups', path: '/management/device-groups',dividerAfter:false },
      { icon: <FileText strokeWidth={1.5} size={20} />, label: 'Templates', path: '/management/templates' ,dividerAfter:false},
      { icon: <Calendar strokeWidth={1.5} size={20} />, label: 'Schedules', path: '/management/schedules' ,dividerAfter:false}
    ],
    dividerAfter:false
  },
  { 
    icon: <Settings strokeWidth={1.5} size={24} />, 
    label: 'System',
    children: [
      { icon: <Cog strokeWidth={1.5} size={20} />, label: 'General', path: '/system/general' ,dividerAfter:false},
      { icon: <UsersIcon strokeWidth={1.5} size={20} />, label: 'Clients', path: '/system/clients',dividerAfter:false },
      { icon: <Briefcase strokeWidth={1.5} size={20} />, label: 'Projects', path: '/system/projects',dividerAfter:false },
      { icon: <MapPin strokeWidth={1.5} size={20} />, label: 'Location', path: '/system/location',dividerAfter:false },
      { icon: <User strokeWidth={1.5} size={20} />, label: 'Users', path: '/system/users',dividerAfter:false },
      { icon: <Shield strokeWidth={1.5} size={20} />, label: 'Roles & Profiles', path: '/system/roles-profiles',dividerAfter:false }
    ],
    dividerAfter:false
  },
  { 
    icon: <Cable strokeWidth={1.5} size={24} />, 
    label: 'Integrations', 
    path: '/integrations' ,
    dividerAfter:false
  },
  { 
    icon: <BarChart3 strokeWidth={1.5} size={24} />, 
    label: 'Reports', 
    path: '/reports' ,
    dividerAfter:false
  },
  { 
    icon: <ClipboardList strokeWidth={1.5} size={24} />, 
    label: 'Logs', 
    path: '/logs',
    dividerAfter: true
  }
  ,
  { 
    icon: <  UserRound strokeWidth={1.5} size={24} />, 
    label: 'Profile', 
    path: '/Profile' ,
    dividerAfter:false
  },
  { 
    icon: <Inbox strokeWidth={1.5} size={24} />, 
    label: 'Notifications', 
    path: '/reports' ,
    dividerAfter:false
  },
  { 
    icon: <Settings strokeWidth={1.5} size={24} />, 
    label: 'Settings', 
    path: '/logs' ,
    dividerAfter:false
  }
];